// @flow
import React from 'react'

// types
import type { DefaultMiniAppProps } from './'
import type { OneQuoteDocuments } from '../../Core/Types/DocumentTypes'
import type { TariffContentType } from '../../Core/Types/TariffsContentType'

type PdfMiniAppProps = DefaultMiniAppProps & {
  miniAppData: {
    documents: OneQuoteDocuments,
    tariffContent: TariffContentType,
  }
}

export default class PdfMiniApp extends React.Component<PdfMiniAppProps> {
  static defaultProps = {
    isBackOffice: false,
  }

  render() {
    const { miniAppData, prefix } = this.props
    const prefixSplit = prefix.split('-')

    if (!miniAppData.tariffContent || !miniAppData.tariffContent.coverages || prefixSplit.length === 0 ||
      !miniAppData.tariffContent.coverages[prefixSplit[0]]) {
      return null
    }

    if (!miniAppData.tariffContent.coverages[prefixSplit[0]].documents) {
      return null
    }

    const documentNames = Object.keys(miniAppData.tariffContent).reduce((acc, tariffKey) => {
      if (miniAppData.tariffContent[tariffKey].help && miniAppData.tariffContent[tariffKey].help.documentNames) {
        acc = {
          ...acc,
          ...miniAppData.tariffContent[tariffKey].help.documentNames
        }
      }
      return acc
    }, {})

    return ([
      <div className='form-group d-flex flex-row flex-wrap flex-sm-row align-items-center' key='PdfMiniApp-content'>
        {miniAppData.tariffContent.coverages[prefixSplit[0]].documents.map((documentKey) => {
          return (
            <strong key={documentKey}>
              <a
                href={miniAppData.documents[documentKey]}
                rel='noopener noreferrer'
                target="_blank"
              >
                <span className="pfp pfp-download pr-2"></span>
                {documentNames[documentKey]}
              </a>
            </strong>
          )
        })}
      </div>
    ])
  }
}
